<template>
  <div class='app-content'>
    <ph-header v-if="platformChannel=='9'">
      <van-icon name="cross" size="20px" slot="left" @click="checkOrder" />
    </ph-header>
    <!-- <download v-if="platformChannel=='10'"></download> -->
    <div class="pay-wrap">
      <section class="pay-head-box">
        <div class="tips_en">FAILURE</div>
        <van-icon name='clear' color='#ccc' size="50px"></van-icon>
        <div class="tips_zh">支付失败</div>
        <div class="upload-message-box" v-if="uploadCertify">
          <div class="tips-zh">
            上传凭证失败
          </div>
          <div class="tips-msg c999">请重新上传</div>
        </div>
        <div class="upload-message-box" v-if="platformChannel=='10'">
          <div class="tips-msg c999">下载并登录“胖虎奢侈品”App，查看订单信息</div>
        </div>
      </section>
      <section class="pay-button-box">
        <div class="button-group" v-if="platformChannel=='9'">
          <van-button round type="ponhu" size="large" @click="checkOrder">查看订单</van-button>
          <van-button plain round size="large" type='ph-default' hairline @click="kefu">咨询客服</van-button>
        </div>
        <div class="button-group" v-if="platformChannel=='10'">
          <van-button round type="ponhu" size="large" @click.stop="kefu">咨询客服</van-button>
          <van-button plain round size="large" type='ph-default' hairline @click.stop="backHome">返回首页</van-button>
        </div>
      </section>
    </div>
    <van-action-sheet v-model="custService">
      <service-sheet @close="custService=false"></service-sheet>
    </van-action-sheet>
  </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import ServiceSheet from '@/components/business/ServiceSheet' 
import Download from '@/components/common/Download'
import { BrowserInfo, getWechatNumber } from '@/utils'
export default {
  name: 'shop_pay_fail',
  components: { PhHeader, Download, ServiceSheet },
  data () {
    return {
      oid: '',
      custService: false,
      uploadCertify: false,
      serviceWechat: {}
    }
  },
  computed: {
    ChannelId () {
      return this.$store.getters.apprChannelId
    },
    platformChannel () {
      return this.$store.getters.platformChannel || '9'
    }
  },
  mounted () {
    // 订单ID
    this.oid = this.$route.query.oid
    // 区分路由 origin == 2 上传凭证
    this.uploadCertify = !!(this.$route.query.orgin && this.$route.query.orgin === 2)
    getWechatNumber().then(res => {
      this.serviceWechat = res;
    });
  },
  methods: {
    checkOrder () {
      this.$router.replace({ name: 'shopOrder' })
    },
    kefu () {
      this.custService = true
    },
    backHome() {
      var pl = BrowserInfo();
      if(pl.isIOS) {
        this.$IOS.IosHome()
      } else {
        this.$Android.AndroidHome()
      }
    },
  }
}
</script>
<style lang='less' scoped >
.pay-wrap{
  display: flex;
  flex-direction: column;
  /* height: calc(100vh - 92px); */
  height: calc(100vh);
  background: #fff;
}
.action-btn {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
}
.pay-head-box{
  font-size: 28px;
  text-align: center;
  /* background: #fff; */
  padding: 80px 24px 30px;
  font-family:STSongti-SC-Regular;
  .tips_en{
    color: #eee;
    font-size: 80px;
    margin-bottom: 10px;
  }
  .tips_zh{
    margin-top: 30px;
    margin-bottom: 48px;
    font-size:36px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:28px;
  }
  .upload-message-box{
    .tips-zh{
      font-size:36px;
      font-weight:400;
      color:rgba(51,51,51,1);
      margin-bottom: 10px;
    }
  }
}
.pay-button-box{
  background: #fff;
  padding: 0 24px;
  flex: auto;
  display: flex;
  justify-content:center;
  align-items: center;
  margin-bottom: 24px;
  .button-group{
    width:100%;
    padding: 0 61px;
    margin-top: 100px;
  }
}
.van-button--ponhu {
  margin-bottom: 18px;
}
</style>
